
<a href="#" mat-button class="mat-primary mat-raised iwg-mat-button sidenavigationassbtn" (click)="showUsEorQuoteDialog($event); $event.preventDefault();" layout="row" *ngIf="ShowGetUSEORQuote && !IsWorker">
    Sales Quote
    <span flex="" class="ng-scope flex"></span>
    <mat-icon mat-font-set="material-icons" class="iconn">add</mat-icon>
</a>

<a mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtn"  layout="row" (click)="showQuoteEstimator($event); $event.preventDefault();" layout="row" *ngIf="ShowEOREstimator">
    EOR Estimator
    <span flex></span>
    <mat-icon mat-font-set="material-icons"class="iconn">add</mat-icon>
</a>

<a mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtn" (click)="showQuoteDialog($event); $event.preventDefault();" layout="row" *ngIf="ShowQuotesButton">
    Get a Quote
    <span flex></span>
    <mat-icon mat-font-set="material-icons"class="iconn">add</mat-icon>
</a>
<a mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtn" (click)="showAssignmentDialog($event); $event.preventDefault();" layout="row" *ngIf="ShowEngageButton">
    Engage a Worker
    <span flex></span>
    <mat-icon mat-font-set="material-icons"class="iconn">add</mat-icon>
</a>
<button mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtn" (click)="showAssignmentDialogWithManagerAndWorker($event,null,null,null,3); $event.preventDefault();" layout="row" *ngIf="showCompliance">
    Evaluate a Contractor
    <span flex></span>
    <mat-icon mat-font-set="material-icons"class="iconn">add</mat-icon>
</button>
<button mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtn" *ngIf="ShowCreateInvoice"
   (click)="showVendorInvoiceDialog($event, null); $event.preventDefault();" layout="row" >
    New Invoice
    <span flex></span>
    <mat-icon mat-font-set="material-icons"class="iconn">add</mat-icon>
</button>

